import { computed } from 'vue'
import { useNuxtApp } from '#app/nuxt'

const useExperiments = () => {
  const { $experiments } = useNuxtApp()
  const { isActive } = $experiments

  return {
    showOdoscopePlp: computed(() => isActive('experiment-plp', 'odoscope-plp')),
    showNewPlp: computed(() => false),
    // TODO: remove this after new PDP is online for a while and we have enough data
    showCheckoutPageNewLayout: computed(() => false),
    showNewGallery: computed(() => isActive('experiment-pdp-gallery', 'new')),
    showPdpUsps: computed(() => false),
    showNewDesktopPlpQuickFilters: computed(() =>
      isActive('experiment-desktop-plp-filters-new', 'new'),
    ),
    showPdpFoldableColors: computed(() =>
      isActive('experiment-pdp-foldable-colors', 'new'),
    ),
    loadLeapScript: computed(() => isActive('experiment-leap-script', 'new')),
    showChooseOneSizeModal: computed(() =>
      isActive('experiment-choose-one-size', 'new'),
    ),
    showPdpSellingPoints: computed(() =>
      isActive('experiment-pdp-selling-points', 'new'),
    ),
    showNewSearchPage: computed(() =>
      isActive('experiment-search-page', 'new'),
    ),
    showReducedRecosSpacing: computed(() =>
      isActive('experiment-recos-spacing', 'new'),
    ),
  }
}

export default useExperiments
